export type SmartyFrontendMessage = {
  analysis: {
    dpv_match_code: string;
    dpv_footnotes: string;
  },
  components: {
    street: string;
    secondary: string;
    city_name: string;
    zipcode: string;
    plus4_code: string;
    state_abbreviation: string;
  },
  metadata: {
    latitude: number,
    longitude: number,
  },
  delivery_line_1: string;
  last_line: string;
  delivery_point_barcode: string;
};

export const EMPTY_ADDRESS_LOOKUP_RESPONSE = { 'lat': null, 'lng': null, 'county': '', 'found_street_number': false, 'census_tract': '' };

export type GoogleMapsAddress = {
  lat: number,
  lng: number,
  formatted_address: string,
  subpremise: string,
  street_number: string,
  street_name: string,
  county: string,
  city: string,
  state: string,
  zipcode: string,
  plus4_code: string,
}

export type GoogleMapsApiAddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
}

export type GoogleMapsApiGeocoderResult = {
  address_components: GoogleMapsApiAddressComponent[];
  formatted_address: string;
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
    location_type: string;
    viewport: {
      northeast: {
        lat: number;
        lng: number;
      };
      southwest: {
        lat: number;
        lng: number;
      };
    };
  };
  partial_match?: boolean;
  place_id: string;
  types: string[];
}

export type GoogleMapsApiGeocoderResponse = {
  results: GoogleMapsApiGeocoderResult[];
  status: string;
}

export type SmartyStreetApiResponse = {
  input_index: number,
  candidate_index: number,
  delivery_line_1: string,
  delivery_line_2?: string,
  last_line: string,
  delivery_point_barcode: string,
  components: {
    primary_number: string,
    street_predirection: string,
    street_postdirection: string,
    street_name: string,
    street_suffix: string,
    secondary_number: string,
    secondary_designator: string,
    city_name: string,
    default_city_name: string,
    state_abbreviation: string,
    zipcode: string,
    plus4_code: string,
    delivery_point: string,
    delivery_point_check_digit: string,
  },
  metadata: {
    record_type: string,
    zip_type: string,
    county_fips: string,
    county_name: string,
    carrier_route: string,
    building_default_indicator: string,
    elot_sequence: string,
    elot_sort: string,
    latitude: number,
    longitude: number,
    precision: string,
    time_zone: string,
    utc_offset: number,
    dst: boolean
  },
  analysis: {
    // See smartyDpvMatchCodeToString below
    dpv_match_code: string,
    dpv_footnotes: string,
    dpv_cmra: string,
    dpv_vacant: string,
    dpv_no_stat: string,
    active: string,
    footnotes: string
  }
}

export type AddressLookupResponse = {
  lat: number | null,
  lng: number | null,
  county: string,
  found_street_number: boolean,
  census_tract: string,
  address?: string,
  building?: string,
  subpremise?: string
  lookups?: Record<string, string>
  smartyResponse?: SmartyFrontendMessage,
  googleMapsResponse?: GoogleMapsAddress,
};

// See https://www.smarty.com/docs/cloud/us-street-api#analysis
export const smartyDpvMatchCodeToString = (dpvMatchCode: string | null | undefined) => {
  switch (dpvMatchCode || 'N') {
    case 'Y': return 'Validated address';
    case 'D': return 'Address is missing subpremise/secondary';
    case 'S': return 'Address has unrecognized subpremise/secondary';
    case 'N': return 'Unvalidated address';
    default: return 'Unknown status';
  }
};
